import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ShowHideTable } from "../../components/ShowHideTable";
import SubHeaderBox from "../../components/SubHeaderBox";
import InventoryPackagingTable from "./Table";
import { getSystemBoundarySubcategory } from "../../../../../apis/Business/InventoryApi";
import inventoryPackagingIcon from "../../../../../assets/design-revamp-company/category-icons/inventory_packaging_delivery_icon.svg";
const InventoryPurchasedPackaging = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState();
  const [systemBoundaryPackaging, setSystemBoundaryPackaging] = useState();
  useEffect(() => {
    getSystemBoundarySubcategory({
      businessId: businessId,
      setSystemBoundarySubCategory: setSystemBoundaryPackaging,
      subcategory: "packaging_purchased",
    });
  }, [businessId]);

  return (
    <div className="component-energy-contents">
      <div style={{ marginTop: "12px" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <SubHeaderBox
            subTitle={t("INVENTORY_PURCHASED_PACKAGING")}
            subDescription={t("INVENTORY_PURCHASED_PACKAGING_DESC")}
            isNormal={true}
            number={"5.1.5B"}
            icon={inventoryPackagingIcon}
            showSystemBoundary={true}
            systemBoundaryProps={{
              businessId: businessId,
              systemBoundary: systemBoundaryPackaging,
              setSystemBoundary: setSystemBoundaryPackaging,
              totalObjCategory: "packaging_purchased",
              customStyles: { marginTop: "10px" },
              isInventory: true,
            }}
          />
        </div>

        {showTable && (
          <InventoryPackagingTable
            businessId={businessId}
            subcategory={"packaging_purchased"}
          />
        )}
        <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
      </div>
    </div>
  );
};

export default InventoryPurchasedPackaging;
